import React, { useState } from 'react';
import { FaFileAlt } from 'react-icons/fa';
import {
  Box,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Button,
  LinkButton,
  Typography,
} from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { useTranslation } from 'react-i18next';
import { AuditRequest } from 'types';

type RequestDetailsProps = {
  details: AuditRequest;
};

export const RequestDetails: React.FC<RequestDetailsProps> = ({ details }) => {
  const { t } = useTranslation('traffic_monitor');
  const [isOpen, setIsOpen] = useState(false);

  const modalHeight = '100vh - 7.5rem';
  const modalHeaderHeight = '4.0625rem';
  const urlSubtitleHeight = '3.625rem';
  const jsonMessageMarginX = '4rem';
  const modalFooterHeight = '6.8125rem';
  const isInboundDirection = details.direction === 'Inbound';

  const formatJsonString = (jsonString: string) => {
    try {
      const dataObj = JSON.parse(jsonString);
      return JSON.stringify(dataObj, null, 4);
    } catch {
      return jsonString;
    }
  };

  return (
    <>
      <LinkButton ml='auto' size='xs' variant='secondary' onClick={() => setIsOpen(true)}>
        {t('view_details', 'View details')}
      </LinkButton>
      <Modal onClose={() => setIsOpen(false)} isOpen={isOpen} scrollBehavior='inside'>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Grid gridAutoFlow='column' gridGap={4}>
              <FaFileAlt color={COLOURS.blue[600]} />
              <span>{t('call_details', 'Call details')}</span>
            </Grid>
            <ModalCloseButton />
          </ModalHeader>
          <ModalBody p='0 !important'>
            <Box
              bg={COLOURS.gray[100]}
              borderTop={`1px solid ${COLOURS.gray[300]}`}
              borderBottom={`1px solid ${COLOURS.gray[300]}`}
              px={8}
              py={4}
            >
              <p>{`${t('url', 'URL')}: ${details.apiUrl}`}</p>
            </Box>
            <Box
              h={`calc(${modalHeight} - ${modalHeaderHeight} - ${urlSubtitleHeight} - ${jsonMessageMarginX} - ${modalFooterHeight})`}
              overflow='auto'
            >
              <Box mb={8}>
                {isInboundDirection && (
                  <div>
                    <Typography px={8} py={4} mt={8}>
                      <h3>{t('response_json', 'ResponseJson')}</h3>
                    </Typography>
                    <Box
                      mx={8}
                      p={4}
                      border={`1px solid ${COLOURS.gray[300]}`}
                      overflow='auto'
                      data-testid='response-json'
                    >
                      <pre>{formatJsonString(details.responseJson)}</pre>
                    </Box>
                  </div>
                )}
                <Typography px={8} py={4} mt={8}>
                  <h3>{t('msg_details', 'MsgDetails')}</h3>
                </Typography>
                <Box
                  mx={8}
                  p={4}
                  border={`1px solid ${COLOURS.gray[300]}`}
                  overflow='auto'
                  data-testid='msg-details'
                >
                  <pre>{formatJsonString(details.detail)}</pre>
                </Box>
              </Box>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => setIsOpen(false)}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
